export enum DIYMasterTypes {
    HTML5Banner = 'HTML5 Banner',
    Print = 'Print',
    Static = 'Static Banner',
}
